module.exports = __webpack_public_path__ + "static/media/beauty.0dd95e6a.webp";